import { RootStore, UserStore, USER_ROLES } from '../../../types';
import { AccountWithGroup } from '../../../utils';

export const selectUser = (state: RootStore):UserStore => state.user;
export const selectAccounts = (state: RootStore): AccountWithGroup[] | null => state.user.accounts.list;
export const selectUserAccounts = (state: RootStore): number[] => state.user.accounts.selected;
export const selectUserRole = (state: RootStore): USER_ROLES => state.user.role;